<template>
    <div id="AppoinmentCalendarResources">
        <h4 class="page-title text-truncate">
            {{ $t('calendarResources.cResources') }}
        </h4>
        <div class="row">
            <div class="col-sm-12 col-md-3" v-if="hasPermissionAdd()">
                <MdButton v-bind:Label="$t('Shared.Add')" v-bind:ClassProp="'btn btn-primary my-3 btn-block btn-login'"
                    v-bind:IconClass="'ti-plus pr-1'" v-on:click="AddCalendarResources"
                    v-bind:Name="'btn_addCalendarResources'">
                </MdButton>
            </div>
            <div v-bind:class="hasPermissionAdd() ? 'col-sm-12 col-md-6 mb-4' : 'col-sm-12 col-md-8 mb-4'">
                <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                    <div class="input-group" dir="ltr">
                        <input type="text" class="form-control" :dir="dirInput" v-model="parameter.SearchCriteria"
                            @keyup.enter="SearchCalendarResources">
                        <div class="input-group-append">
                            <div class="input-group-append">
                                <MdButton v-bind:Name="'btnsearchinput'"
                                    v-bind:VariantProp="'btn btn-sm search-attached'"
                                    v-bind:IconClass="'mdi mdi-magnify'" v-on:click="SearchCalendarResources">
                                </MdButton>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-12 col-md-3">
                <MdSelect v-bind:Label="$t('Shared.EmployeeType')" v-bind:Options="EmployeeTypeSourceList"
                    v-bind:FieldDescription="'description'" v-bind:FieldCode="'code'" v-bind:Model="EmployeeTypeModel"
                    v-bind:Multiple="true" :Input="ChangeDropDownEmployeeType">
                </MdSelect>
            </div>
        </div>
        <div class="row">
            <div class="col-12 mt-2">
                <MdTitle v-bind:Text="$t('Shared.SearchResult')" v-bind:isSubtitle="true"
                    v-bind:Name="'T_TitleSearch'" />
                <div class="row">
                    <div class="col-md-12">
                        <MdTable v-bind:fields="fields" v-bind:items="items" v-bind:totalRows="totalRows"
                            v-bind:isReadOnly="false" v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
                            v-bind:currentPage="currentPage" v-bind:perPage="perPage" v-bind:pageOptions="pageOptions"
                            :editIconEvent="this.EditCalendarResources" v-bind:VisibleEditIcon="hasPermissionEdit()"
                            :deleteIconEvent="RemoveCalendarResources" v-bind:VisibleDeleteIcon="hasPermissionDelete()"
                            :onRowSelected="onRowSelected" :onFiltered="onFiltered" :pageChanged="pageChanged"
                            :perPageFunction="PerPageFunction">
                        </MdTable>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import DBFunctions from '@/common/DBFunctions.js'
import ShowMessage from '@/components/messages/ShowMessage.js'
import CalendarResourcesService from '@/services/calendarresources.service'
import EmployeeTypesService from '@/services/employeetypes.service'
import Permission from '@/common/Permission'

export default {
    name: 'CalendarResourcesLIST',
    mixins: [ShowMessage, DBFunctions, Permission],
    data() {
        return {
            //permission: [],
            //Menu : this.$store.state.leftMenu,
            parameter: {
                SearchCriteria: '',
                PageNumber: 0,
                PageSize: 0,
                Type: '',
                EmployeeTypeList: []
            },
            EmployeeTypeSourceList: [],
            EmployeeTypeModel: [],
            OptionsRightMenu: {
                visible: false,
                ItemsList: [],
                btnvisible: false,
                itemdisabled: false,
                PatientCode: '',
                Mode: this.edit_mode,
                favButtonAtion: false
            },
            totalRows: 0,
            currentPage: 1,
            perPage: 10,
            ShowMessageIsEmpty: false,
            pageOptions: [5, 10, 15],
            items: [],
            doubleBookMap: {
                'A': this.$t('calendarResources.dbList.A'),
                'W': this.$t('calendarResources.dbList.W'),
                'P': this.$t('calendarResources.dbList.P')
            },
            typeModel: { text: this.$t('Shared.All'), value: 'All' },
            TypeList: [
                { text: this.$t('Shared.All'), value: 'All' },
                { text: this.$t('Shared.CPT'), value: 'CPT' },
                { text: this.$t('Shared.HCPCS'), value: 'HCPCS' },
                { text: this.$t('cpt.Revenue'), value: 'Revenue' },
                { text: this.$t('calendarResourcesList.UserDefined'), value: 'UserDefined' },
            ],
            fields: [
                { key: 'employeeName', sortable: true, label: this.$tc('Shared.Employee', 1), class: 'text-rigth' },
                { key: 'employeeType', sortable: true, label: this.$t('Shared.EmployeeType'), class: 'text-rigth' },
                                {
                    key: 'dobleBook',
                    sortable: true,
                    label: this.$t('calendarResources.dBooking'),
                    class: 'text-rigth',
                    formatter: value => (
                        this.doubleBookMap && this.doubleBookMap[value]) ?
                            this.doubleBookMap[value] : (value || '')
                },
            ],
            dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr',
        }
    },

    methods: {

        ChangeType(type) {
            this.typeModel = type;
            this.getCalendarResources();
        },

        ChangeDropDownEmployeeType(value) {
            this.EmployeeTypeModel = value;
            this.parameter.EmployeeTypeList = value ? value.map(x => x.code) : [];
            this.SearchCalendarResources();
        },

        getEmployeeTypesListing() {
            const param = {
                Active: true
            };
            this.EmployeeTypeSourceList = [];
            EmployeeTypesService.getAllEmployeeType(param)
                .then((response) => {
                    if (response.status == '200' && response.data) {
                        response.data.forEach(element => {
                            this.EmployeeTypeSourceList.push({
                                code: element.code,
                                description: element.description
                            });
                        });
                    }
                })
                .catch((error) => {
                    this.showResponseErrorMessage(error);
                });
        },

        AddCalendarResources() {
            this.emitDataforFavorites();
            this.$router.push({ name: "calendarresources-add" }).catch(() => { });
        },

        EditCalendarResources(row) {
            this.$router.push({ name: "calendarresources-details", params: { id: row.employeeCode } });
        },



        SearchCalendarResources() {
            this.items = []
            this.currentPage = 1;
            this.parameter.PageNumber = 1;
            this.totalRows = this.items.length;
            this.getCalendarResources();
        },

        getCalendarResources() {
            this.$emit('load', true);
            this.parameter.PageNumber = this.currentPage;
            this.parameter.PageSize = this.perPage;
            this.parameter.RestrictAccess = false;
            CalendarResourcesService.getAllCalendarResources(this.parameter)
                .then((response) => {
                    if (response.status == '200' && response.data) {
                        this.items = response.data;
                        this.$emit('load', false);
                        let headerString = response.headers["x-pagination"];
                        this.totalRows = JSON.parse(headerString).TotalCount;
                    }
                })
                .catch((error) => {
                    this.showResponseErrorMessage(error);
                    /*if (!error.response) {             
                      this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
                  }                      
                    else if(error.response.status === 400 ){
                      this.showMessage(this.$tc('Msg.Error'),error.response.data.errorMessage,"error");
                    }
                    else if(error.response.status === 405 ){             
                          this.$router.push({name: "Main"});    
                            setTimeout(() => 
                                this.showPermissionMessage()
                                , 50);            
                    } 
                    else if(error.response.status === 500){
                      this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.ThereWereSomeError'),"error");
                    } else{
                      this.showMessage(this.$tc('Msg.Error'),error.response.data.errorMessage,"error");
                    } */
                    this.$emit('load', false);
                });
        },

        RemoveCalendarResources(row) {
            const Id = row.employeeCode;
            this.$bvModal.msgBoxConfirm(this.$t('Msg.DeleteRecord'), {
                title: this.$tc('Shared.DelRecord'),
                okTitle: this.$t('Shared.TitleDelete'),
                cancelTitle: this.$t('Shared.BtnCancel'),
                footerClass: 'p-2',
                titleClass: 'modal-title modal-type-warning',
                id: 'modal_delete_CalendarResources'
            })
                .then(value => {
                    if (value) {
                        this.$emit('load', true);
                        CalendarResourcesService.Delete(Id)
                            .then(() => {
                                const index = this.items.findIndex(item => item.code === Id)
                                if (~index) {
                                    this.items.splice(index, 1)
                                    this.getCalendarResources();
                                }
                            })
                            .catch((error) => {
                                this.$emit('load', false);
                                /*if(error.response.status === 400 ){
                                 this.showMessage(this.$tc('Msg.Error'),error.response.data.errorMessage,"error");
                                 }else{
                                    this.showMessage(this.$tc('Msg.Error'),error,"error");
                                 }*/
                                this.showResponseErrorMessage(error);
                            });
                    }
                })
        },

        onRowSelected() {

        },
        onFiltered() {

        },
        pageChanged(page) {
            this.currentPage = page;
            this.getgetCalendarResources();
        },
        PerPageFunction(perpage) {
            this.perPage = perpage;
            this.currentPage = 1;
            this.getCalendarResources();
        }
    },

    mounted() {
        this.getEmployeeTypesListing();
        this.OptionsRightMenu.ItemsList = [];
        let layoutStatus = this.$store.state.layoutStatus;
        switch (layoutStatus) {
            case 'L0R1':
                this.OptionsRightMenu.favButtonAtion = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            case 'L1R0':
            case 'L1R1':
                this.OptionsRightMenu.btnvisible = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            default:
                this.OptionsRightMenu.favButtonAtion = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
        }
        this.getCalendarResources();
    },

    destroyed() {
        this.OptionsRightMenu.ItemsList = [];
        this.OptionsRightMenu.Mode = false;
        this.OptionsRightMenu.visible = false;
        this.$emit('getVisibleMenu', this.OptionsRightMenu);
    }

};
</script>